import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import MobileMenu from "./MobileMenu"; // pastikan path-nya sesuai

const HeaderComponent = () => {
    const location = useLocation();
    const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

    const toggleNav = () => {
        console.log("Toggle Mobile Nav:", !isMobileNavOpen);
        setIsMobileNavOpen(!isMobileNavOpen);
    };

    const closeMobileNav = () => {
        if (isMobileNavOpen) {
            setIsMobileNavOpen(false);
        }
    };

    return (
        <>
            <header id="header" className="fixed-top header-transparent">
                <div className="container d-flex align-items-center justify-content-between">
                    <div className="logo">
                        <a href="#">
                            <img src={`${process.env.PUBLIC_URL}/sampang.png`} alt="Sampang" />
                        </a>
                    </div>
                    {/* Untuk tampilan desktop */}
                    <nav id="navbar" className="navbar d-none d-lg-block">
                        <ul>
                            <li>
                                <a
                                    className={`nav-link scrollto ${location.pathname === "/#open_data" ? "active" : ""}`}
                                    href="#open_data"
                                >
                                    Open Data
                                </a>
                            </li>
                            {/* <li>
                                <a
                                    className={`nav-link scrollto ${location.pathname === "/#dashboard" ? "active" : ""}`}
                                    href="#dashboard"
                                >
                                    Dashboard
                                </a>
                            </li> */}
                            <li>
                                <a
                                    className={`nav-link scrollto ${location.pathname === "/#peta_digital" ? "active" : ""}`}
                                    href="#peta_digital"
                                >
                                    Peta Digital
                                </a>
                            </li>
                            <li>
                                <a
                                    className={`nav-link scrollto ${location.pathname === "/#statistik_sektoral" ? "active" : ""}`}
                                    href="#statistik_sektoral"
                                >
                                    Statistik Sektoral
                                </a>
                            </li>
                        </ul>
                    </nav>

                    {/* Tombol toggle untuk mobile */}
                    <i
                        className={`bi mobile-nav-toggle d-lg-none ${isMobileNavOpen ? "bi-x" : "bi-list"}`}
                        onClick={toggleNav}
                    ></i>
                </div>
            </header>

            {/* Render MobileMenu menggunakan Portal */}
            <MobileMenu isOpen={isMobileNavOpen} closeMobileNav={closeMobileNav} location={location} />
        </>
    );
};

export default HeaderComponent;